import type { ChipTone } from '@/components/common/StatusChip';
import type { DocumentReceivedStatus } from '@/types/shared';

/** Chip tone per the tri-state D2 document status — mirrors `lib/studentStatus.ts`'s pattern. */
const TONE_BY_DOCUMENT_STATUS: Record<DocumentReceivedStatus, ChipTone> = {
  'Not Received': 'neutral',
  Received: 'success',
  'Received — Needs Correction': 'warning',
};

export function toneForDocumentStatus(status: DocumentReceivedStatus): ChipTone {
  return TONE_BY_DOCUMENT_STATUS[status] ?? 'neutral';
}

/** G5 (server-mirrored, `student-affairs.service.ts`): the copy-count stepper is only meaningful
 * once a document has actually been received in some form. */
export function isCopiesCountEditable(status: DocumentReceivedStatus): boolean {
  return status !== 'Not Received';
}

/** Business rule: a document marked 'Received' must have at least 1 copy on file. */
export function isCopiesCountRequired(status: DocumentReceivedStatus): boolean {
  return status === 'Received';
}

/** Business rule: 'Received — Needs Correction' must carry an explanatory note. */
export function isNotesRequired(status: DocumentReceivedStatus): boolean {
  return status === 'Received — Needs Correction';
}
